<template>
  <v-container>
    <v-row>
      <v-col
          md="3"
          sm="4"
          xs="6"
          cols="6"
          v-for="item in list"
          :key="item.index"
      >
        <div class="card-item" :draggable="draggable" @dragstart="onDragStart($event, item)">
          <div
              class="card-preview"
              @click="$emit('preview', item)"
              :class="{ 'card-preview-bg': !item.thumbnail }"
          >
            <v-img
                v-if="item.thumbnail"
                :lazy-src="item.thumbnail"
                :src="item.thumbnail"
                height="100%"
                cover
            />
            <v-icon v-else color="white">mdi-image-multiple</v-icon>
          </div>
          <h6>{{ item.name }}</h6>
          <p>{{ item.categoryName }}</p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
    },
    draggable: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    onDragStart(event, item) {
      this.$emit('drag-item', event, item);
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  &-preview {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 94px;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 8px;
    cursor: pointer;
    &-bg {
      background-image: radial-gradient(circle at 50% 0, #86b6f7, #4e7fed 96%);
    }
  }
  &-item {
    h6 {
      font-size: 10px;
      font-weight: 500;
      color: $label-color;
      margin-bottom: 8px;
    }
    p {
      font-size: 12px;
      line-height: 1.67;
      margin-bottom: 8px;
    }
  }
}
</style>
